import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const logout = async (): Promise<void> => {
  await axiosAuth({
    url: "/auth/logout",
    method: "post",
  })
  return undefined
}
